import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';

const LookupContext = createContext();

export const LookupProvider = ({ children }) => {
    const [lookups, setLookups] = useState({
        personas: {},
        intents: {},
        industries: {},
        focusAreas: [], // Matches your backend plural key
        positions: [] // Admin-managed positions
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLookups = async () => {
            try {
                const response = await api.get('/meta/lookups');
                setLookups(response.data);
            } catch (error) {
                console.error("Failed to fetch lookup data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchLookups();
    }, []);

    return (
        <LookupContext.Provider value={{ lookups, loading }}>
            {children}
        </LookupContext.Provider>
    );
};

export const useLookups = () => {
    const context = useContext(LookupContext);
    if (!context) {
        throw new Error("useLookups must be used within a LookupProvider");
    }
    return context;
};